import { CREATEWORKSPACE_FAIL, CREATEWORKSPACE_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const createWorkspaceReducer = (state = initialState, action) => {
	switch (action.type) {
		case CREATEWORKSPACE_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case CREATEWORKSPACE_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default createWorkspaceReducer;
